<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :rules="dataForm.rulesCompanyGroup"
        :submit="handleSubmitFormAddGroup"
        :undo-enable="true"
        :title="$t('labels.addCompanyGroup')"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div
                    class="hts-vehicles-ignore-add-vehicle__container-body"
                    :class="sizeItemInput">
                    <hts-card :title="$t('labels.generalInformation')">
                        <div class="grid gap-5">
                            <group-name
                                v-model="dataFormAddCompanyGroup.name"
                                name="name"
                                prop="name" />
                            <group-type
                                v-model="dataFormAddCompanyGroup.type"
                                name="type"
                                prop="type" />
                            <hts-form-input
                                :required="true"
                                :label="$t('labels.companyName')"
                                :placeholder="companyName"
                                :color="props.color"
                                :disabled="true"
                                name="company"
                                prop="company" />
                            <hts-form-input
                                v-model="dataFormAddCompanyGroup.description"
                                :label="$t('labels.description')"
                                :color="props.color"
                                name="description"
                                prop="description" />
                        </div>
                    </hts-card>
                    <hts-card :title="$t('labels.groupPermissions')">
                        <div class="flex align-middle justify-end mb-2">
                            <span class="text-lg font-bold">
                                {{ $t('labels.checkAll') }}
                            </span>
                            <input
                                class="mt-2 ml-2"
                                type="checkbox"
                                :checked="isCheckAll"
                                @change="(e) => actionCheckAll()" >
                        </div>
                        <permission-checkbox
                            :permissions="permissionRef"
                            :action-checkbox="actionCheckbox"
                            :action-sub-checkbox="actionSubCheckbox"
                            :data-group-permissions="dataGroupPermissions" />
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import PermissionCheckbox from '../-components/ignore/permission-checkbox.vue'
import GroupName from './ignore/group-name.vue'
import GroupType from './ignore/group-type.vue'
import dataForm from './imports/model'
import permissions from '~/data/permissions/trucker/index'
const store = $store()
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
  resetValue()
})

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: [String, Number],
    default: 'screen-lg'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})
const dataGroupPermissions = ref<Array<String>>([])
const permissionRef = reactive([...permissions])
const isCheckAll = ref(false)
const emits = defineEmits(['close', 'refreshTables'])

const resetValue = () => {
  dataGroupPermissions.value = []
}

const closeOverSide = () => {
  emits('close')
}

const dataFormAddCompanyGroup = ref({ ...dataForm.initValue })
const undo = () => {
  dataFormAddCompanyGroup.value = { ...dataForm.initValue }
}
const actionCheckbox = (e: any, permission: any, action: boolean) => {
  e.stopPropagation()
  if (action) {
    if (!dataGroupPermissions.value.includes(permission.permissionKey)) {
      dataGroupPermissions.value.push(permission.permissionKey)
    }
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permission.permissionKey
    })
  }

  if (!permission.children) {
    return
  }

  permission.children.map((item: any) => {
    return actionCheckbox(e, item, action)
  })
  parentCheck()
}

const actionSubCheckbox = (e: any, permissionKey: string) => {
  if (!dataGroupPermissions.value.includes(permissionKey)) {
    dataGroupPermissions.value.push(permissionKey)
  } else {
    dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
      return ele !== permissionKey
    })
  }
  parentCheck()
}

const parentCheck = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  const result = data.map((item: any) => {
    if (!item.children) {
      return false
    }

    const check = item.children.map((children: { [key: string]: any }) => {
      if (children.children) {
        return parentCheck([children])
      }
      return dataGroupPermissions.value.includes(children.permissionKey)
    })

    if (check.includes(true)) {
      if (!dataGroupPermissions.value.includes(item.permissionKey)) {
        dataGroupPermissions.value.push(item.permissionKey)
      }
      return true
    } else {
      dataGroupPermissions.value = dataGroupPermissions.value.filter(function (ele) {
        return ele !== item.permissionKey
      })
      return false
    }
  })

  return result.includes(true)
}

const actionCheckAll = (permission?: Array<any> | undefined) => {
  const data = permission && Array.isArray(permission) ? permission : permissionRef
  if (!permission) {
    isCheckAll.value = !isCheckAll.value
  }
  if (!isCheckAll.value) {
    dataGroupPermissions.value = []
    return
  }
  data.map((item: any) => {
    if (!dataGroupPermissions.value.includes(item.permissionKey)) {
      dataGroupPermissions.value.push(item.permissionKey)
    }

    if (!item.children) {
      return item
    }

    item.children.map((subItem: any) => {
      if (!subItem.children) {
        if (subItem.isDisabled !== undefined) {
          subItem.isDisabled = !isCheckAll.value
        }
        dataGroupPermissions.value.push(subItem.permissionKey)
        return ''
      } else {
        return actionCheckAll([subItem])
      }
    })
    return ''
  })
}

const handleSubmitFormAddGroup = async () => {
  const api = $url.companyGroup.addGroup
  const dataRequest = { ...dataFormAddCompanyGroup.value, permissions: dataGroupPermissions.value }
  const response = await $api(api, { body: dataRequest })
  if (!response) {
    return true
  }
  const responseData: any = response.data?.value
  if (responseData.success) {
    resetValue()
    dataGroupPermissions.value = []
    emits('refreshTables')
    process.client && $toast().success($t('labels.addSuccess'))
    emits('close')
    undo()
  }
}
</script>
